export default "__VITE_ASSET__CkyJye6w__"